import styled from "styled-components";

export const SelectedQuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 24px;
  padding-right: 8px;
  overflow-y: scroll;

  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.disabledMeatballItem};
    border-radius: 10px;
  }
`; 

export const SelectedQuestionIndex = styled.h2`
  color: ${(props) => props.theme.colors.constrat};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const SelectedQuestionTitle = styled.h3`
  color: ${(props) => props.theme.colors.constrat};
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const ChartTitle = styled.span`
  color: ${(props) => props.theme.colors.constrat};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const ChartWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

